// DS: PO56
import React from 'react';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { Trans, useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import Button from '../../Button';
import s from './CookiesBanner.scss';
var CookiesBanner = function (_a) {
    var onAccept = _a.onAccept, onManageInfo = _a.onManageInfo;
    var t = useTranslation().t;
    var handleManageInfoClick = function (e) {
        onManageInfo();
        e.preventDefault();
        return false;
    };
    var handleAcceptClick = function (e) {
        onAccept();
    };
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['details'] },
            React.createElement(Trans, { i18nKey: "popup.cookiesbanner.details" },
                "We use cookies to enhance your experience, analyze site traffic, and for our marketing purposes. ",
                React.createElement("a", { href: URLS.PRIVACY }, "Learn More")),
            React.createElement("br", null),
            React.createElement(Trans, { i18nKey: "popup.cookiesbanner.manage_info" },
                "Manage your",
                ' ',
                React.createElement(BiLink, { className: s['manage-info'], onClick: handleManageInfoClick, href: "#" }, "personal settings."))),
        React.createElement("div", { className: s['buttons'] },
            React.createElement(Button, { view: 'b1-1', height: 'small', minWidth: '120px', fullWidth: true, onClick: handleAcceptClick, className: s['accept'] }, t('popup.cookiesbanner.accept')))));
};
CookiesBanner.displayName = 'CookiesBanner';
export default CookiesBanner;
//# sourceMappingURL=CookiesBanner.js.map